import * as z from "zod/v4";

export const UlidSchema = z.ulid().describe("ID (ULID)");

export type Ulid = z.infer<typeof UlidSchema>;
